import { Directive, inject } from '@angular/core';
import { MessageInputService } from '@libs/collaboration';
import { AssistantLauncherService } from './assistant-launcher.service';
import { AssistantMessageInputRegistry } from './assistant-message-input';

/**
 * Gives the message input on the same element the draft of the assistant collaboration that is current when it mounts.
 * The provider resolves once per element, so the chat window remounts the message input when the collaboration changes:
 * the leaving input saves its text into its own draft, and the new one renders the draft of the new collaboration.
 */
@Directive({
  selector: '[libAssistantMessageInputScope]',
  providers: [
    {
      provide: MessageInputService,
      useFactory: (): MessageInputService => inject(AssistantMessageInputRegistry).get(inject(AssistantLauncherService).collabId()),
    },
  ],
})
export class AssistantMessageInputScopeDirective {}
